module.exports = __webpack_public_path__ + "img/insec_abduction.d75d7acd.svg";